module.exports = App.RegistrableMixin = Em.Mixin.create
  _register: (->
    @set('registerAs', @)
  ).on('didInsertElement')